<template lang="pug">
  v-container#container.mt-2.pa-0(fluid)
    v-container#postal.pa-0(fluid justify-center)
      v-container.postal.px-0.mt-3.pb-0(fluid)
        v-layout.header.mr-0(row wrap)
          v-flex(d-flex xs12 sm4)
            v-layout(column)
              v-flex(d-flex xs1)
                v-card.pl-3.mt-2.justify-center.align-center(d-flex flat)
                  img.info(src="static/logo.png")
          v-flex.pb-2(d-flex xs12 sm8)
            v-layout.pl-3(column)
              v-flex(d-flex xs12)
                v-card.fill(flat)
                  v-flex(d-flex xs12 fill-height align-center)
                    h1.head.title {{stateVisible ? (record.state || 'Entidad') : ''}}
                    p.head.subtitle.dark-text.pl-2.mr-3(fill-height align-center) Folio {{'#' + record.folio}}
        v-layout.pl-3.pr-3.pt-1.aggression(row wrap d-flex fill-height align-content-center)
          v-flex.mt-5(d-flex xs3)
            v-card(flat d-flex).pr-2
              img.mt-3(width="100%" title="Cambiar imagen" fluid alt="profile img" v-if="(typeof record.foto == 'string')" :src="record.foto")
              img.mt-3(width="100%" title="Cambiar imagen" fluid alt="profile img" v-if="!(typeof record.foto == 'string')" src="static/upload-icon.png")
          v-flex.pl-3(xs9 align-center)
            v-layout.mx-0.where(row wrap)
              v-flex.border.pl-2(d-flex xs6)
                v-card(flat).fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.content-title(v-if="aggressionDateVisible") {{dateFormattedMomentjs(record.aggressionDate)}}
              v-flex.border.pl-2(d-flex xs6)
                v-card(flat).fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.content-title {{municipalityVisible ? (record.municipality && record.municipality.lenght > 22 ? record.municipality.substr(0,19) + '...' : record.municipality) : ''}}{{municipalityVisible && record.municipality ? ',' : ''}} {{stateVisible ? record.state : ''}}
            v-layout.mx-0.when(row wrap)
              v-flex.pl-2(d-flex xs6)
                v-card(flat).fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1
                    p.info-title Fecha del hecho
              v-flex.pl-2(d-flex xs6)
                v-card(flat).fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1
                    p.info-title Municipio / Estado

            v-layout.mx-0.where(row wrap)
              v-flex.border(d-flex xs12)
                v-card(flat).fill-height.align-center.d-flex
                  v-card-text.pa-0
                    p.black-content-title {{legalNameVisible ? record.legalName : ''}}
            v-layout.mx-0.when(row wrap)
              v-flex(d-flex xs12)
                v-card(flat).fill-height.align-center.d-flex
                  v-card-text.px-0.pt-0.pb-1
                    p.info-title Nombre legal

            v-layout.mx-0.where(row wrap)
              v-flex.border(d-flex xs12)
                v-card(flat).fill-height.align-center.d-flex
                  v-card-text.pa-0
                    p.black-content-title {{chosenNameVisible ? record.chosenName : ''}}
            v-layout.mx-0.when(row wrap)
              v-flex(d-flex xs12)
                v-card(flat).fill-height.align-center.d-flex
                  v-card-text.px-0.pt-0.pb-1
                    p.info-title Nombre elegido o asumido

            v-layout.mx-0.where(row wrap)
              v-flex.border(d-flex xs12)
                v-card(flat).fill-height.align-center.d-flex
                  v-card-text.pa-0
                    p.black-content-title {{whereWasFoundVisible ? (record.whereWasFound == 'Otro' && record.whereWasFoundOther ? record.whereWasFoundOther : record.whereWasFound) : ''}}
            v-layout.mx-0.when(row wrap)
              v-flex(d-flex xs12)
                v-card(flat).fill-height.align-center.d-flex
                  v-card-text.px-0.pt-0.pb-1
                    p.info-title Lugar donde apareció el cuerpo

            v-layout.mx-0.where(row wrap)
              v-flex.border(d-flex xs12)
                v-card(flat).fill-height.align-center.d-flex
                  v-card-text.pa-0
                    p.black-content-title {{sexualIdentityVisible ? (record.sexualIdentity == 'Otro' && record.sexualIdentityOther ? record.sexualIdentityOther : record.sexualIdentity) : ''}}
            v-layout.mx-0.when(row wrap)
              v-flex(d-flex xs12)
                v-card(flat).fill-height.align-center.d-flex
                  v-card-text.px-0.pt-0.pb-1
                    p.info-title Identidad de género/Orientación sexual percibida


        v-layout.px-3.mb-0(row wrap)
          v-flex.mx-0.where(xs12)
            v-layout.my-0(row wrap)
              v-flex.border(d-flex xs4)
                v-card(flat).fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{ageVisible ? record.age : ''}}
              v-flex.border(d-flex xs4)
                v-card(flat).fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{nationalityVisible ? record.nationality : ''}}
              v-flex.border(d-flex xs4)
                v-card(flat).fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{occupationVisible ? (record.occupation == 'Otro' && record.occupationOther ? record.occupationOther : record.occupation) : ''}}
          v-flex.mx-0.when(xs12)
            v-flex(xs12)
              v-layout.my-0(row wrap)
                v-flex(d-flex xs4)
                  v-card(flat).fill-height.align-center.text-xs-center.d-flex
                    v-card-text.pt-0.pb-1
                      p.info-title Edad
                v-flex(d-flex xs4)
                  v-card(flat).fill-height.align-center.text-xs-center.d-flex
                    v-card-text.pt-0.pb-1
                      p.info-title Nacionalidad
                v-flex(d-flex xs4)
                  v-card(flat).fill-height.align-center.text-xs-center.d-flex
                    v-card-text.pt-0.pb-1
                      p.info-title Ocupación

        v-layout.px-3.mt-0(row wrap)
          v-flex.mx-0.where(xs12)
            v-layout.my-0(row wrap)
              v-flex.border(d-flex xs4)
                v-card(flat).fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{characteristicVisible ? (record.characteristic == 'Otro' && record.characteristicOther ? record.characteristicOther : record.characteristic) : ''}}
              v-flex.border(d-flex xs4)
                v-card(flat).fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{bodyStateVisible ? (record.bodyState == 'Otro' && record.bodyStateOther ? record.bodyStateOther : record.bodyState) : ''}}
              v-flex.border(d-flex xs4)
                v-card(flat).fill-height.align-end.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title {{weaponVisible ? (record.weapon == 'Otro' && record.weaponOther ? record.weaponOther : record.weapon) : ''}}
          v-flex.mx-0.where(xs12)
            v-layout.my-0(row wrap)
              v-flex(d-flex xs4)
                v-card(flat).fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Característica diferencial
              v-flex(d-flex xs4)
                v-card(flat).fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Estado del cuerpo
              v-flex(d-flex xs4)
                v-card(flat).fill-height.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1.px-1
                    p.info-title Arma


        v-layout.pl-3.pr-2.my-2(row wrap align-center)
          v-flex.text-xs-center.pr-1.postal-link(xs4 v-if="record.mainMediaLink && mainMediaLinkVisible")
            a.dark-text.bold.small(target="_blank" href="record.mainMediaLink") {{record.mainMediaLink}}
            p.text-xs-center.bolder.small Liga a la nota principal
          v-flex.pl-1(xs8)
            v-layout.my-0(row wrap)
              v-flex(d-flex xs3)
                v-flex.ml-1(xs4)
                  p.ma-0.bold.small Sí
                v-flex.ml-1(xs4)
                  p.ma-0.bold.small No
                v-flex.ml-1(xs4)
                  p.ma-0.bold.small S/D
            v-layout.mr-0.my-0(row wrap)
              v-flex.checkbox-form-group(d-flex xs3 v-if="tortureViolenceVisible")
                v-checkbox.form-check-input(v-model="selection" value="tortureViolence-si" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="selection" value="tortureViolence-no" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="selection" value="tortureViolence-sd" hide-details disabled color="red darken-3")
              v-flex.checkbox-form-group(d-flex xs3 v-if="!tortureViolenceVisible")
                v-checkbox.form-check-input(v-model="unselect" value="tortureViolence-si" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="unselect" value="tortureViolence-no" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="unselect" value="tortureViolence-sd" hide-details disabled color="red darken-3")
              v-flex(d-flex xs9)
                p.bold.small.checks.ml-3 ¿Hubo indicios de ensañamiento?
            v-layout.mr-0.my-0(row wrap)
              v-flex.checkbox-form-group(d-flex xs3 v-if="sexualViolenceVisible")
                v-checkbox.form-check-input(v-model="selection" value="sexualViolence-si" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="selection" value="sexualViolence-no" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="selection" value="sexualViolence-sd" hide-details disabled color="red darken-3")
              v-flex.checkbox-form-group(d-flex xs3 v-if="!sexualViolenceVisible")
                v-checkbox.form-check-input(v-model="unselect" value="sexualViolence-si" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="unselect" value="sexualViolence-no" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="unselect" value="sexualViolence-sd" hide-details disabled color="red darken-3")
              v-flex(d-flex xs9)
                p.bold.small.checks.ml-3 ¿Hubo indicios de violencia sexual?
            v-layout.mr-0.my-0(row wrap)
              v-flex.checkbox-form-group(d-flex xs3 v-if="wasOffenderFoundVisible")
                v-checkbox.form-check-input(v-model="selection" value="wasOffenderFound-si" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="selection" value="wasOffenderFound-no" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="selection" value="wasOffenderFound-sd" hide-details disabled color="red darken-3")
              v-flex.checkbox-form-group(d-flex xs3 v-if="!wasOffenderFoundVisible")
                v-checkbox.form-check-input(v-model="unselect" value="wasOffenderFound-si" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="unselect" value="wasOffenderFound-no" hide-details disabled color="red darken-3")
                v-checkbox.form-check-input(v-model="unselect" value="wasOffenderFound-sd" hide-details disabled color="red darken-3")
              v-flex(d-flex xs9)
                p.bold.small.checks.ml-3 ¿Hubo detenido?
        v-layout.px-3.details(row wrap)
          v-flex.my-0(xs12)
            p.details-title.px-4.bold.pt-1.pb-0 Descripción de los hechos:
          v-flex.my-0(xs12)
            p.details-box {{detailsVisible ? record.details : ''}}
  // uncomment to activate review layout
    Reviews(v-if="path !== '/form'")
</template>

<script>
import Reviews from "@/components/Reviews.vue";
import moment from "moment";

export default {
  name: "Postal",
  props: {},
  components: {
    Reviews
  },
  data() {
    return {
      unselect: [],
    };
  },
  computed: {
    path() {
      return this.$router.currentRoute.path;
    },
    record() {
      //console.log(this.$store.getters.record, this.$store.getters.record.folio);
      return this.$store.getters.record;
    },
    selection() {
      const sexualViolence = this.record.sexualViolence;
      const tortureViolence = this.record.tortureViolence;
      const wasOffenderFound = this.record.wasOffenderFound;
      let selection = [];

      if (sexualViolence == "Sí") {
        selection.push('sexualViolence-si');
      } else if (sexualViolence == "No") {
        selection.push('sexualViolence-no');
      } else if (sexualViolence == "S/D") {
        selection.push('sexualViolence-sd');
      }

      if (tortureViolence == "Sí") {
        selection.push('tortureViolence-si');
      } else if (tortureViolence == "No") {
        selection.push('tortureViolence-no');
      } else if (tortureViolence == "S/D") {
        selection.push('tortureViolence-sd');
      }

      if (wasOffenderFound == "Sí") {
        selection.push('wasOffenderFound-si');
      } else if (wasOffenderFound == "No") {
        selection.push('wasOffenderFound-no');
      } else if (wasOffenderFound == "S/D") {
        selection.push('wasOffenderFound-sd');
      }
      return selection;
    },
    aggressionDateVisible() {
      return this.$store.state.record.aggressionDateVisible;
    },
    stateVisible() {
      return this.$store.state.record.stateVisible;
    },
    municipalityVisible() {
      return this.$store.state.record.municipalityVisible;
    },
    legalNameVisible() {
      return this.$store.state.record.legalNameVisible;
    },
    chosenNameVisible() {
      return this.$store.state.record.chosenNameVisible;
    },
    whereWasFoundVisible() {
      return this.$store.state.record.whereWasFoundVisible;
    },
    sexualIdentityVisible() {
      return this.$store.state.record.sexualIdentityVisible;
    },
    characteristicVisible() {
      return this.$store.state.record.characteristicVisible;
    },
    ageVisible() {
      return this.$store.state.record.ageVisible;
    },
    nationalityVisible() {
      return this.$store.state.record.nationalityVisible;
    },
    occupationVisible() {
      return this.$store.state.record.occupationVisible;
    },
    detailsVisible() {
      return this.$store.state.record.detailsVisible;
    },
    bodyStateVisible() {
      return this.$store.state.record.bodyStateVisible;
    },
    weaponVisible() {
      return this.$store.state.record.weaponVisible;
    },
    sexualViolenceVisible() {
      return this.$store.state.record.sexualViolenceVisible;
    },
    tortureViolenceVisible() {
      return this.$store.state.record.tortureViolenceVisible;
    },
    wasOffenderFoundVisible() {
      return this.$store.state.record.wasOffenderFoundVisible;
    },
    mainMediaLinkVisible() {
      return this.$store.state.record.mainMediaLinkVisible;
    }
  },
  methods: {
    dateFormattedMomentjs (value) {
      return value ? moment(value).format('DD/MM/YYYY') : '';
    }
  },
  mounted() {
    // console.log(this.stateColors)
    // console.log(this.record)
  }
};
</script>

<style src="./postal.scss" lang="scss">
</style>
